module.exports = __webpack_public_path__ + "img/2023无人飞行器智能感知技术竞赛.79ef6aae.jpg";